import CommonCard from "../../components/ui/CommonCard/CommonCard";
import DollarIcon from "../../icons/DollarIcon";
import WalletRemoveIcon from "../../icons/WalletRemoveIcon";
import WalletWithCoinIcon from "../../icons/WalletWithCoinIcon";
import classes from "./Pool.module.css";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Colors,
} from "chart.js";
import axios from "axios";
import { env } from "../../constants/env";
import { useEffect, useState } from "react";

// Register required components
ChartJS.register(ArcElement, Tooltip, Legend);

const Pool = () => {
  const token = localStorage.getItem("token");

  const [statsData, setStatsData] = useState(null);
  const [page, setPage] = useState(0);
  const limit = 0;

  console.log("FINANCE ADATA ", statsData);

  const statsList = [
    {
      icon: <DollarIcon />,
      amount: `${statsData?.balance ? statsData?.balance : 0}`,
      title: "Current Balance",
    },
    {
      icon: <WalletRemoveIcon />,
      amount: `${statsData?.withdrawals ? statsData?.withdrawals : 0}`,
      title: "Withdrawals",
    },
    {
      icon: <WalletWithCoinIcon />,
      amount: `${
        statsData?.totalContribution ? statsData?.totalContribution : 0
      }`,
      title: "Contributions",
    },
  ];

  useEffect(() => {
    fetchFinanceData(page);
  }, [page]);

  const fetchFinanceData = async (page) => {
    try {
      const response = await axios.get(
        `${env.apiUrl}/api/finance?page=${page}&limit=${limit}`
      );
      console.log("CHECK BALANCE", response.data);
      setStatsData(response.data);
    } catch (error) {
      console.error("Error fetching finance data:", error);
    }
  };

  function parseCurrency(value) {
    if (!value || typeof value !== "string") return 0; // fallback for null/undefined
    const numeric = Number(value.replace(/[$,]/g, ""));
    return isNaN(numeric) ? 0 : numeric;
  }

  const numericInitialFunding = parseCurrency(statsData?.initialFunding);
  const numericTotalContribution = parseCurrency(statsData?.totalContribution);

  const data = {
    labels: ["Initial Funding", "Challenge Fees Added"], // Simplified legend labels
    datasets: [
      {
        data: [numericInitialFunding, numericTotalContribution],
        backgroundColor: ["#30970B", "#970B0B"],
        hoverBackgroundColor: ["#30970B", "#970B0B"],
        borderWidth: 0, // No borders on segments
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        title: {
          display: true,
          text: "",
          color: "#fff",
        },
        labels: {
          padding: 20,
          font: {
            size: 14,
          },
          boxWidth: 8, // Set the width of the legend box
          boxHeight: 8, // Set the height of the legend box
          // usePointStyle: true, // Makes the box style customizable
          // pointStyle: "rectRounded", // Rounded rectangle shape
          generateLabels: (chart) => {
            const dataset = chart.data.datasets[0];
            return chart.data.labels.map((label, index) => ({
              text: label,
              fillStyle: dataset.backgroundColor[index],
              strokeStyle: dataset.backgroundColor[index],
              Colors: dataset.backgroundColor[index],
              hidden: false,
              lineWidth: 0,
            }));
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.raw || 0;
            return `$${value.toLocaleString()}`;
          },
        },
      },
      datalabels: {
        formatter: (value, context) => {
          const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return `$${value.toLocaleString()} (${percentage}%)`;
        },
        color: "#fff",
        // backgroundColor: "#000",
        borderRadius: 3,
        padding: 4,
        align: "end", // Align the lines pointing outward
        anchor: "end", // Attach labels to the line endpoints
      },
    },
  };

  return (
    <div className={classes.wrapper}>
      <div className="d-flex align-items-center justify-content-between mt-3">
        <h3>Pool</h3>
      </div>
      <div className="row mt-4">
        {statsList.map((item, i) => (
          <div className="col-4" key={i}>
            <CommonCard className={`${classes.card} `}>
              <div className="d-flex flex-column gap-3">
                <div className={classes.icon}>{item.icon}</div>
                <div>
                  <h2 className={classes.amount}>{item.amount}</h2>
                  <p className={classes.title}>{item.title}</p>
                </div>
              </div>
            </CommonCard>
          </div>
        ))}
      </div>
      <CommonCard className={`${classes.chartCard} `}>
        <h3>Funding sources</h3>
        <div className="d-flex align-items-center justify-content-between mt-3">
          <div style={{ width: "400px", margin: "0 auto" }}>
            <Pie data={data} options={options} />
          </div>
        </div>
      </CommonCard>
    </div>
  );
};

export default Pool;
